import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { mockHandle } from './mockData';
export default function createConnection(baseURL, projectId, clientKey) {
    const api = axios.create({
        baseURL: baseURL,
        timeout: 30_000,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        auth: {
            username: projectId,
            password: clientKey,
        },
    });
    api.interceptors.request.use((config) => {
        if (config?.data?.method && config.baseURL?.includes('?')) {
            config.baseURL = config.baseURL + `&method=${config?.data?.method}`;
        }
        if (!config.data) {
            config.data = {};
        }
        if (config.data.chainId && config.baseURL) {
            config.baseURL = config.baseURL.replace(/chainId=\d+/, `chainId=${config.data.chainId}`);
        }
        if (config.data.isPublic && config?.baseURL && !config?.baseURL?.includes?.('/public')) {
            config.baseURL = config?.baseURL?.replace(/\?/, '/public?');
        }
        config.data.id = uuidv4();
        config.data.jsonrpc = '2.0';
        return config;
    });
    mockHandle(api);
    return api;
}
//# sourceMappingURL=connection.js.map